import React, { useEffect, useRef, useState, forwardRef, useImperativeHandle } from "react";
import ReactECharts from "echarts-for-react";
import PainTimelineCard from "./PainTimelineCard";


// TODO: FIX STATES WHERE SUGERY DATA EXISTS FOR THE SELECTED TIME RANGE BUT DIARY DATA DOES NOT
const ActivityLevelChart = forwardRef(function ActivityLevelChart(props, ref) {
    const {
        getColorMapping: getColorMapping
    } = props;
    const chartRef = useRef(null);
    const [option, setOption] = useState({});
    const [tooltipData, setTooltipData] = useState(null);
    const initializeHighlight = useRef(true);
    const lastForcedHighlight = useRef(-1);
    const currentIndex = useRef(0)
    const diary = useRef(null)
    const cardVisible = useRef(true);

    // TODO: THIS IS DUPLICATED
    const getMobileTooltipConfig = () => ({
        trigger: "axis",
        confine: true,
        appendToBody: false,
        symbolSize: 30,
        axisPointer: {
            type: "none"
        },
        formatter: function (params) {
            return "";
        }
    });

    const buildOption = (ctx = {}, minDate, maxDate) => {
        if (!diary.current?.entries?.length) return {};
        currentIndex.current = diary.current.entries.length - 1
        const colorMap = ctx.colorMap || getColorMapping(diary.current.attributes);

        return {
            legend: {
                data: [
                    "Activity Level",
                ]
            },
            tooltip: getMobileTooltipConfig(),
            xAxis: {
                type: "time",
                axisLabel: {},
            },
            yAxis: {
                gridIndex: 0,
                min: 0,
                axisLabel: {
                    formatter: function (value) {
                        if (value === -1) {
                        } else if (value < 0) {
                            return '';
                        }
                        return value;
                    },
                    rich: {
                    }
                }
            },
            grid: {
                top: "10%",
                left: "1%",
                right: "1%",
                bottom: "3%",
                containLabel: true
            },
            "series": [
                {
                    "name": "Activity Level",
                    "type": "line",
                    "smooth": true,
                    showSymbol: false,
                    "color": colorMap.get('Activity Level'),
                    symbolSize: 10,
                    "data": diary.current.entries.map(entry => {
                        return {
                            value: [
                                entry.createdAt.replace("T", " ").replace("Z", ""),
                                entry.activityLevel
                            ],
                            notes: entry.notes
                        }
                    }),
                    "emphasis": {
                        "focus": "series"
                    }
                }
            ]
        }
    }

    useImperativeHandle(ref, () => ({
        update: (newDiary, ctx = {}, minDate, maxDate) => {
            diary.current = newDiary
            initializeHighlight.current = true
            const newOption = buildOption(ctx, minDate, maxDate);
            if (Object.keys(newOption).length) setOption(newOption);
            dispatchAction("highlight", newDiary.entries.length - 1)
        },
        getEChartsInstance: () => chartRef.current?.getEchartsInstance?.()
    }), [])


    const chartIsReady = (echartsInstance) => {
        if (!echartsInstance) {
            console.log("echartsInstance does not exist")
            return;
        }

        echartsInstance.on('highlight', function (params) {
            if (params?.batch?.[0]) {
                currentIndex.current = params.batch[0].dataIndex
                cardVisible.current = true
                setTooltipData({});
            }
            if (params?.mstephens || params?.[0]?.mstephens || params?.batch?.[0]?.mstephens) {
                return
            }
            if (lastForcedHighlight.current !== -1) {
                if (params.batch?.[0].dataIndex !== lastForcedHighlight.current) {
                    dispatchAction("downplay", lastForcedHighlight.current)
                }
            }
            setTooltipData({ "1": "2" })
            lastForcedHighlight.current = params?.batch?.[0]?.dataIndex
        });
        echartsInstance.on('downplay', function (params) {
            if (!params?.batch?.[0]?.mstephens && params?.batch?.length) {
                if (lastForcedHighlight.current !== currentIndex.current) {
                    dispatchAction("downplay", lastForcedHighlight.current)
                }
                lastForcedHighlight.current = currentIndex.current
                dispatchAction("highlight", lastForcedHighlight.current)
            }
        });
        echartsInstance.on('finished', function () {
            if (initializeHighlight.current) {
                initializeHighlight.current = false
                if (lastForcedHighlight.current != diary.current.entries.length - 1) {
                    dispatchAction("downplay", lastForcedHighlight.current)
                }
                dispatchAction("highlight", diary.current.entries.length - 1)
            }
        });




        console.log("*** all event listeners initialized ***")

    }

    const closeCard = () => {
        cardVisible.current = false
        if (lastForcedHighlight.current != -1) {
            dispatchAction("downplay", lastForcedHighlight.current)
        }
        setTooltipData({ "1": "2" })
    }
    const leftClick = () => {
        if (currentIndex.current < 1) {
            return
        }
        dispatchAction("downplay", currentIndex.current)
        dispatchAction("highlight", currentIndex.current - 1)
    }

    const rightClick = () => {
        if (currentIndex.current > diary.current.entries.length - 2) {
            return
        }
        dispatchAction("downplay", currentIndex.current)
        dispatchAction("highlight", currentIndex.current + 1)
    }

    const dispatchAction = (action, index) => {
        const echartsInstance = chartRef.current?.getEchartsInstance();

        if (!echartsInstance) {
            console.log("EARLY RETURN ON DISPATCH ACTION")
            return;
        }

        if (action === "highlight") {
            lastForcedHighlight.current = index
        }
        echartsInstance.dispatchAction({
            type: action,
            escapeConnect: true,
            mstephens: true,
            batch: [
                {
                    "mstephens": true,
                    "seriesIndex": 0,
                    "dataIndexInside": index,
                    "dataIndex": index,
                    "type": action,
                    "escapeConnect": true,
                    "notBlur": true,
                    "batch": null
                }
            ]
        })
    }

    return (
        <div className="review-card" style={{ marginBottom: '1rem', overflow: 'hidden' }}>
            <h3 style={{ textAlign: 'center' }}>Activity History</h3>
            <div style={{ width: "100%", position: 'relative' }}>
                <div style={{ width: "100%", height: "300px", overflow: 'hidden' }}>
                    <ReactECharts
                        ref={chartRef}
                        option={option || {}}
                        style={{ height: "100%" }}
                        onChartReady={(instance) => chartIsReady(instance)}
                    />
                </div>
            </div>
            {diary.current?.entries?.length > 0 && (
                <PainTimelineCard
                    diary={diary.current}
                    currentIndex={currentIndex}
                    leftClick={leftClick}
                    rightClick={rightClick}
                    getColorMapping={getColorMapping}
                    closeCard={closeCard}
                    cardVisible={cardVisible.current}
                    isPain={false}
                    toast={props.toast}
                    loadDiary={props.loadDiary}
                    canEdit={props.canEdit}
                />
            )}
        </div>
    );
})

export default ActivityLevelChart;